import React from "react";
import { ArrowRight, Lock, PhoneCall, Scale, ShieldCheck } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { TRUST_PORTAL_URL, finalCtaBadges, whoWeServe } from "../data/siteContent";
import OverlappingShields from "./OverlappingShields";

const iconMap = { PhoneCall, Scale, ShieldCheck };

const FinalCTA = () => {
  return (
    <section
      className="relative bg-ink py-28 sm:py-44 overflow-hidden"
      data-testid="final-cta-section"
    >
      <div className="absolute inset-0">
        <img
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover opacity-25"
          src={whoWeServe[1].image}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/85 to-ink" />
      </div>

      <OverlappingShields
        size={460}
        opacity={0.08}
        duration={60}
        className="hidden sm:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      />

      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.05]">
            Own Nothing.{" "}
            <span className="block text-gold italic mt-2">Control Everything.</span>
          </h2>
          <p className="text-cream/75 text-base sm:text-lg leading-relaxed mt-8 max-w-2xl mx-auto">
            Go through the portal at your own pace. See everything set up
            before you pay a single dollar. You will receive a personal call
            before anything finalizes.
          </p>

          <div
            className="max-w-2xl mx-auto mt-12 bg-surface/70 backdrop-blur-sm border border-gold/25 rounded-2xl px-7 sm:px-10 py-7 text-left sm:text-center"
            data-testid="security-promise"
          >
            <div className="flex items-center justify-start sm:justify-center gap-2.5 text-gold text-xs tracking-[0.28em] uppercase font-semibold">
              <Lock className="w-[14px] h-[14px]" /> Your Information Is Safe
            </div>
            <p className="text-cream/80 text-sm sm:text-base leading-relaxed mt-4">
              Your information is protected with military grade encryption. We
              never sell or share your data. Your SSN is secured the moment
              it is entered and is only accessible to your case
              administrator.
            </p>
            <p className="font-display italic text-gold text-base sm:text-lg mt-3">
              This is not just policy. This is our promise.
            </p>
          </div>

          <a
            href={TRUST_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-btn"
            className="group inline-flex items-center gap-3 bg-gold text-ink font-bold tracking-[0.1em] uppercase text-sm sm:text-base px-10 py-5 rounded-full mt-10 hover:bg-goldlight transition-colors duration-300 shadow-[0_0_60px_rgba(201,162,60,0.45)]"
          >
            Start Your Portal Now
            <ArrowRight className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-x-1.5" />
          </a>

          <div className="flex flex-col sm:flex-row justify-center gap-5 sm:gap-10 mt-14">
            {finalCtaBadges.map((badge) => {
              const Icon = iconMap[badge.icon];
              return (
                <div
                  key={badge.text}
                  className="flex items-center justify-center gap-2.5 text-cream/70 text-sm"
                >
                  <Icon className="w-4 h-4 text-gold" /> {badge.text}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
